module.exports = __webpack_public_path__ + "static/media/Icon material-arrow-drop-down.c67dc22a.svg";